const RL_FILTERS_KEY = '@REQUISITION_LISTS/FILTERS';
const RFQ_FILTERS_KEY = '@RFQ_VIEW/FILTERS';

const parseJSON = (value) => {
  try {
    return JSON.parse(value) || {};
  } catch {
    return {};
  }
};

export const saveRLFilters = (filters) => {
  const stored = parseJSON(localStorage.getItem(RL_FILTERS_KEY));
  const updated = { ...stored };

  if (filters.rl_number !== undefined) updated.rl_number = filters.rl_number;
  if (filters.vessel_imo !== undefined) updated.vessel_imo = filters.vessel_imo;
  if (filters.search !== undefined) updated.rl_search = filters.search;
  if (filters.pagination !== undefined) updated.rl_pagination = filters.pagination;
  if (filters.status !== undefined) updated.rl_status = filters.status;
  if (filters.importance !== undefined) updated.rl_importance = filters.importance;

  localStorage.setItem(RL_FILTERS_KEY, JSON.stringify(updated));
};

export const saveRFQFilters = (filters) => {
  const stored = parseJSON(localStorage.getItem(RFQ_FILTERS_KEY));
  const updated = { ...stored };

  if (filters.rl_number !== undefined) updated.rl_number = filters.rl_number;
  if (filters.vessel_imo !== undefined) updated.vessel_imo = filters.vessel_imo;
  if (filters.search !== undefined) updated.rfq_search = filters.search;
  if (filters.pagination !== undefined) updated.rfq_pagination = filters.pagination;
  if (filters.status !== undefined) updated.rfq_status = filters.status;

  localStorage.setItem(RFQ_FILTERS_KEY, JSON.stringify(updated));
};

export const loadRLFilters = () => {
  const rlStored = parseJSON(localStorage.getItem(RL_FILTERS_KEY));
  const rfqStored = parseJSON(localStorage.getItem(RFQ_FILTERS_KEY));

  return {
    rl_number: rlStored.rl_number || rfqStored.rl_number,
    vessel_imo: rlStored.vessel_imo || rfqStored.vessel_imo,
    search: rlStored.rl_search,
    pagination: rlStored.rl_pagination,
    status: rlStored.rl_status,
    importance: rlStored.rl_importance,
  };
};

export const loadRFQFilters = () => {
  const rlStored = parseJSON(localStorage.getItem(RL_FILTERS_KEY));
  const rfqStored = parseJSON(localStorage.getItem(RFQ_FILTERS_KEY));

  return {
    rl_number: rfqStored.rl_number || rlStored.rl_number,
    vessel_imo: rfqStored.vessel_imo || rlStored.vessel_imo,
    search: rfqStored.rfq_search,
    pagination: rfqStored.rfq_pagination,
    status: rfqStored.rfq_status,
  };
};
